module.exports = __webpack_public_path__ + "img/平面设计部.0f74a6cc.jpg";